<template>
  <b-form-datepicker
    :id="id"
    :name="name"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :min="min"
    :max="max"
    class="form-control input_sm date-field"
    locale="es"
    :start-weekday="1"
    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
    today-button
    reset-button
    close-button
    label-no-date-selected="Sin fecha seleccionada"
    label-today-button="Hoy"
    label-reset-button="Borrar"
    label-close-button="Cerrar"
    label-prev-year="Año anterior"
    label-prev-month="Mes anterior"
    label-current-month="Mes actual"
    label-next-month="Mes siguiente"
    label-next-year="Año siguiente"
    label-today="Hoy"
    label-selected="Fecha seleccionada"
    label-help="Use las flechas del teclado para navegar por el calendario"
    @input="$emit('input', $event)"
  ></b-form-datepicker>
</template>

<script>
/**
 * Campo de fecha de la aplicación.
 *
 * Sustituye a <input type="date">, cuyo formato visible lo impone el locale del
 * navegador (en/US muestra mm/dd/yyyy) y no puede forzarse desde la página.
 * Aquí se muestra siempre dd/mm/yyyy, mientras que el v-model sigue siendo la
 * cadena ISO "YYYY-MM-DD" que espera el backend.
 */
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BFormDatepicker } from 'bootstrap-vue';

export default {
  name: 'DateField',
  components: { BFormDatepicker },
  props: {
    value: { type: String, default: '' },
    id: { type: String, default: null },
    name: { type: String, default: null },
    placeholder: { type: String, default: 'dd/mm/aaaa' },
    disabled: { type: Boolean, default: false },
    min: { type: String, default: null },
    max: { type: String, default: null },
  },
}
</script>

<!-- El alto, los bordes y el radio se definen en public/css/app/style.css,
     junto con el resto de campos, para mantener una única línea de diseño. -->
